import React from 'react';
import { Box } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { ButtonHot, BUTTON_MODE } from 'components/common/ButtonHot';
import { ModalHot } from 'components/common/ModalHot';
import LogoutIcon from 'assets/personal_zone/logout.svg';
import { IconHot } from 'components/common/IconHot';
import { useTranslations } from 'common/hooks/useTranslations';
export const LogoutModal = ({
  open,
  onClose,
  onConfirm,
  testID = 'logout-modal',
}) => {
  const { translate } = useTranslations();
  return (
    <ModalHot
      open={open}
      onClose={onClose}
      testID={testID}
    >
      {({ isMobile }) => (
        <Box
          dir="rtl"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
          }}
        >
          {/* Icon */}
          <Box
            testId={`${testID}-icon`}
            sx={{
              width: 80,
              height: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: `${spacing.lg}px`,
            }}
          >
            <IconHot
              src={LogoutIcon}
              size={100}
            />
          </Box>

          {/* Title */}
          <TextHot
            testID={`${testID}-title`}
            size="xxl"
            bold="bold"
            color="primary"
            isLtr={true}
            sx={{ marginBottom: `${spacing.xl}px`, textAlign: 'center' }}
          >
            {translate('personal_zone_logout_modal_title')}
          </TextHot>

          {/* Buttons */}
          <Box
            testId={`${testID}-buttons`}
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row-reverse',
              gap: `${spacing.sm}px`,
              width: '100%',
            }}
          >
            <ButtonHot
              testID={`${testID}-cancel-btn`}
              mode={BUTTON_MODE.PRIMARY}
              onClick={onClose}
              sx={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                borderRadius: `${radius.xl}px`,
                padding: `${spacing.md}px`,
              }}
            >
              {translate('logout_modal_no_text')}
            </ButtonHot>
            <ButtonHot
              testID={`${testID}-confirm-btn`}
              mode={BUTTON_MODE.OUTLINED}
              onClick={onConfirm}
              sx={{
                flex: isMobile ? 'none' : 1,
                width: isMobile ? '100%' : 'auto',
                borderRadius: `${radius.xl}px`,
                padding: `${spacing.md}px`,
                border: `1px solid ${colors.system.border.default}`,
                color: colors.system.text.primary,
              }}
            >
              {translate('personal_zone_logout')}
            </ButtonHot>
          </Box>
        </Box>
      )}
    </ModalHot>
  );
};

export default LogoutModal;

